import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import CertificatesView from "../components/certificates/CertificatesView";

const Certificates = () => {
  return (
    <AdminLayout>
      <CertificatesView />
    </AdminLayout>
  );
};

export default Certificates;
